import React from 'react';

type ClientStatus = 'Active' | 'Lead' | 'Past';
type ReminderStatus = 'Pending' | 'Done' | 'Cancelled';
type PaymentStatus = 'Pending' | 'Paid' | 'Overdue';
type AppointmentStatus = 'Scheduled' | 'Completed' | 'Cancelled' | 'No Show';

interface EntityStatusBadgeProps {
  type: 'client' | 'reminder' | 'payment' | 'appointment';
  status: ClientStatus | ReminderStatus | PaymentStatus | AppointmentStatus;
  className?: string;
}

const statusConfig = {
  client: {
    Active: 'bg-[#5B8E87]/10 text-[#5B8E87]',
    Lead: 'bg-[#C9A870]/10 text-[#C9A870]',
    Past: 'bg-gray-100 text-gray-600',
  },
  reminder: {
    Pending: 'bg-[#C9A870]/10 text-[#C9A870]',
    Done: 'bg-[#5B8E87]/10 text-[#5B8E87]',
    Cancelled: 'bg-red-100 text-red-600',
  },
  payment: {
    Pending: 'bg-[#C9A870]/10 text-[#C9A870]',
    Paid: 'bg-[#5B8E87]/10 text-[#5B8E87]',
    Overdue: 'bg-red-100 text-red-600',
  },
  appointment: {
    Scheduled: 'bg-blue-100 text-blue-600',
    Completed: 'bg-[#5B8E87]/10 text-[#5B8E87]',
    Cancelled: 'bg-red-100 text-red-600',
    'No Show': 'bg-orange-100 text-orange-600',
  },
};

export default function EntityStatusBadge({ type, status, className = '' }: EntityStatusBadgeProps) {
  const config = statusConfig[type];
  const colorClass = config[status as keyof typeof config];

  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-medium ${colorClass} ${className}`}
    >
      {status}
    </span>
  );
}
